<template>
  <div class="h1">
    {{ user.libellePersonne }},
  </div>

  <p>
    Vous avez demandé à bénéficier d'une assurance complémentaire santé {{ user.libelleProduit }} et nous vous
    remercions de votre confiance.
  </p>
</template>

<script>
export default {
  name: "RecapitulatifFinal",
  props: {
    user: {
      type:Object,
      required: true
    }
  }
}
</script>

<style scoped>

</style>
